<template>
  <header>
    <div class="header-container">
      <div class="logo">
        <img src="../../assets/images/logo-2.png" alt="" />
      </div>
      <div class="link">
        <router-link to="/home">{{ $t("common.navigation.title.home") }}</router-link>
        <router-link to="/about" :class="{ active: $route.path === '/about' }">
          {{ $t("common.navigation.title.about") }}
        </router-link>
        <router-link to="/query" :class="{ active: $route.path === '/query' }">
          {{ $t("common.navigation.title.query") }}
        </router-link>
        <router-link to="/track" :class="{ active: paths.includes($route.path) }">
          {{ $t("common.navigation.title.track") }}
        </router-link>
        <router-link to="/contact" :class="{ active: $route.path === '/contact' }">
          {{ $t("common.navigation.title.contact") }}
        </router-link>
      </div>
      <div class="language">
        <change-language></change-language>
      </div>
    </div>
    <div class="mask">
      <div class="mask-content">
        <h1>
          <template v-if="$i18n.locale === 'en-US'"> {{$route.meta.en}} </template>
          <template v-else-if="$i18n.locale === 'ru-RU'"> {{$route.meta.ru}}</template>
          <template v-else-if="$i18n.locale === 'uk-UK'"> {{$route.meta.uk}} </template>
          <template v-else>{{$route.meta.en}}</template>
        </h1>
        <div class="nav">
          <router-link to="/home">{{$t('common.navigation.title.home')}}</router-link>
          <span>&nbsp;&nbsp;·&nbsp;&nbsp;</span>
          <router-link to="/about" class="active" v-if="$route.path === '/about'">
            {{$t('common.navigation.title.about')}}
          </router-link>
          <router-link to="/query" class="active" v-else-if="$route.path === '/query'">
            {{$t('common.navigation.title.query')}}
          </router-link>
          <router-link to="/track" class="active" v-else-if="paths.includes($route.path)">
            {{$t('common.navigation.title.track')}}
          </router-link>
          <router-link to="/contact" class="active" v-if="$route.path === '/contact'">
            {{$t('common.navigation.title.contact')}}
          </router-link>
        </div>
      </div>
    </div>
  </header>
</template>

<script>
import ChangeLanguage from '@/components/ChangeLanguage/ChangeLanguage'
export default {
  props: {

  },
  components:{ChangeLanguage},
  data() {
    return {
      top: 0,
      paths:['/track/russia','/track/belarus','/track/kazakhstan','/track/mongolia','/track/UKraine','/track/Uzbekistan']
    };
  },
  mounted(){
    // console.log(this.$route);
  },
  methods: {

  },
};
</script>

<style lang="less" scoped>
/* 头部区域 */
header {
  position: relative;
  height: 496px;
  background: url("../../assets/images/about/about-01.webp") no-repeat;
  background-size: 100% 100%;
  .header-container {
    overflow: hidden;
    display: flex;
    justify-content: center;
    align-items: center;
    padding:24px 48px 0;
    .logo {
      z-index: 999;
      width: 160px;
      color: #fff;
      img {
        width: 100%;
        
      }
    }
    .link {
      z-index: 999;
      display: flex;
      justify-content: space-around;
      align-items: center;
      width: 999px;
      margin: 0 auto;
      a {
        // padding: 0 24px 0 0;
        color: #fff;
        font-size: 16px;
        text-decoration: none;
        &:hover {
          color: #ff5d1b;
        }
      }
      .active {
        color: #ff5d1b;
      }
    }
    .language {
      z-index: 999;
      select {
        background: transparent;
        border: none;
        color: #fff;
      }
    }
  }

  .mask {
    z-index: 1;
    position: absolute;
    top: 0;
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: rgba(0, 0, 0, 0.8);
    .mask-content {
      margin: 0 auto;
      width: 50%;
      h1 {
        font-size: 48px;
        color: #ff5d1b;
      }
      .nav {
        color: #fff;
        a {
          color: #fff;
          font-size: 16px;
          text-decoration: none;
          &:hover {
            color: #ff5d1b;
          }
        }
        .active {
          color: #ff5d1b;
        }
      }
    }
  }
}
</style>